export const breakbefore = {
  type: 'boolean',
  value: false,
  displayTitle: 'Insert page break before',
};
